import { gql } from '@apollo/client';

export const SEND_SMS = gql`
mutation sendSMS($phone : String!) {
  sendSMS(phone: $phone) {
    data
    status
    error
  }
}
`;

export const VERIFY_SMS = gql`
mutation verifySMS($phone : String!, $code : String!) {
  verifySMS(phone: $phone, code: $code) {
    data
    status
    error
  }
}
`;

export const SEND_TRANSACTION = gql`
mutation sendTransaction($paymentdata : CloudSpacePurchaseDetails!, $transactionid : String!) {
  sendTransaction(paymentdata: $paymentdata, transactionid: $transactionid) {
    data
    status
    error
  }
}
`;

export const ACTIVATE_CLOUDSPACE = gql`
mutation activateCloudSpace($phone : String!, $code : String!) {
  activateCloudSpace(phone: $phone, code: $code) {
    data
    status
    error
  }
}
`;